var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, css, html, LitElement } from "lit-element";
import i18n from 'roddeh-i18n';
let SeznamAuthButton = class SeznamAuthButton extends LitElement {
    constructor() {
        super();
        this.authError = null;
        this.clientId = '';
        this.addEventListener('click', this.onClick);
    }
    onClick(e) {
        e.preventDefault();
        this.authError = null;
        this.dispatch('signing', {});
        // Otwarcie popupu, który spowoduje przekierowanie do nas wraz z kodem autoryzacji i state
        const state = Date.now().toFixed(0);
        const uri = `https://login.szn.cz/api/v1/oauth/auth?client_id=${encodeURIComponent(this.clientId)}&scope=identity,contact-phone&response_type=code&redirect_uri=https://${window.location.hostname}/seznam/return&state=${encodeURIComponent(state)}`;
        const popup = this.popupWindow(uri, 'Seznam.cz', window, 500, 600);
        if (popup === null) {
            this.dispatch('canceled', {});
            return;
        }
        // Ustawiane na true po obsłudze poprawnej odpowiedzi lub zamknięciu okna
        let responseHandled = false;
        // Obsługa odpowiedzi wysłanej w ramach popupach przez /seznam/return (strona powrotu z Seznam.cz)
        window.addEventListener('message', (e) => {
            if (e.origin !== `https://${window.location.hostname}`) {
                return;
            }
            const data = e.data;
            if (typeof (data) !== 'object' || typeof (data.type) === 'undefined' || data.type !== 'seznam-auth') {
                return;
            }
            if (data.state !== state) {
                return;
            }
            // Wiadomość dotyczy autoryzacji Seznam
            e.preventDefault();
            e.stopPropagation();
            responseHandled = true;
            if (!data.success) {
                const eventData = {};
                if (data.error !== null) {
                    eventData.error = data.error;
                }
                this.showErrors(eventData);
                this.dispatch('canceled', data);
                return;
            }
            if (!data.logged) {
                this.dispatch('signed', {
                    type: 'account_created',
                    source: 'Seznam',
                    firstName: data.data.firstName,
                    lastName: data.data.lastName,
                    email: data.data.email,
                    phoneNumber: data.data.phoneNumber,
                });
            }
            else {
                const eventData = {
                    type: 'logged',
                    firstName: data.data.firstName ?? '',
                    lastName: data.data.lastName ?? '',
                };
                if (data.redirectTo !== null) {
                    eventData.redirectTo = data.redirectTo;
                }
                this.dispatch('signed', eventData);
            }
        });
        // Detekcja zamknięcia popupa bez przesyłania odpowiedzi
        const timer = setInterval(() => {
            if (popup.closed) {
                clearInterval(timer);
                // Zabezpieczenie przed wysłaniem eventu canceled, kiedy okno zostanie poprawnie zamknięte
                if (!responseHandled) {
                    this.dispatch('canceled', {});
                }
            }
        }, 1000);
    }
    showErrors(data) {
        if (typeof (data.error) === 'undefined') {
            return;
        }
        this.authError = data.error;
    }
    popupWindow(url, windowName, win, w, h) {
        const y = win.top === null ? 0 : win.top.outerHeight / 2 + win.top.screenY - (h / 2);
        const x = win.top === null ? 0 : win.top.outerWidth / 2 + win.top.screenX - (w / 2);
        return win.open(url, windowName, `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`);
    }
    dispatch(name, details) {
        const event = new CustomEvent(name, {
            detail: details,
            bubbles: true,
            composed: true
        });
        this.dispatchEvent(event);
    }
    static get styles() {
        return css `
        :host {
            cursor: pointer;
            user-select: none;
            display: inline-block;
        }

        .btn {
            background: #CC0000;
            display: flex;
            align-items: center;
            width: 288px;
            height: 40px;
            padding: 4px;
            box-sizing: border-box;
            color: #fff;
            font-weight: bold;
            transition: 0.3s ease-out background-color;
        }
        .btn:hover {
            background: #aa0000;
        }
        .btn > img {
            height: 20px;
            width: 20px;
            margin: 6px;
        }
        .btn > span {
            margin: 0.5em;
            display: block;
            text-align: center;
            flex: 1;
        }

        .error {
            background-color: #ffd1d1;
            padding: 0.5em;
            box-sizing: border-box;
            color: #b30000;
            width: 288px;
            font-size: 0.8em;
            font-weight: 600;
            text-align: center;
            cursor: default;
         }
        `;
    }
    render() {
        return html ` <div class="seznam-signin-wrapper">
              <div class="btn">
                <img src="/img/seznam-logo.svg">
                <span>${i18n('NRF Log in using Seznam.cz')}</span>
              </div>
              ${this.authError !== null ? html `
              <div class="error">${this.authError}</div>
              ` : ''}
            </div>`;
    }
};
__decorate([
    property({ type: String })
], SeznamAuthButton.prototype, "authError", void 0);
__decorate([
    property({ type: String })
], SeznamAuthButton.prototype, "clientId", void 0);
SeznamAuthButton = __decorate([
    customElement('seznam-auth-button')
], SeznamAuthButton);
export default SeznamAuthButton;
